/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { isGumCase } from '@brands/Utils/isGumCase';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useLocation, useParams } from 'react-router-dom';
import { isAxiosError } from 'axios';
import { parsePhoneNumber } from 'libphonenumber-js';
import { heicTo } from 'heic-to';
import { pdf } from '@react-pdf/renderer';
import { toast } from 'react-toastify';
import { isEqual } from 'lodash';

import { Dialog, DialogContent, DialogTitle, List, ListItemButton, ListItemText } from '@mui/material';
import Container from '../../Components/Container/Container';
import { Loading } from '../../Components/LoadingSpinner/Loading';
import { useWindowSize } from '../../hooks';
import { useAppDispatch, useAppSelector } from '../../hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import useCases from '../../hooks/useCases';
import useSubscribe, { Subscriber } from '../../hooks/useSubscribe';

import { validationSchema } from '@brands/Dashboard/ConsultationPage/assets/validationSchema';
import {
  consultationFormDefaultValues,
  editImageNoteDefaultValues,
  removeAttachmentDefaultValues,
  removeImageDefaultValues,
  unassignProviderModalDefaultValues,
} from './assets/defaultValues';
import { OralHealthReportSubmit } from './assets/types';

import { selectAuth } from '@brands/store/selectors/auth';
import { selectSidebarState } from '@brands/store/selectors/sidebarState';
import { selectOneReport } from '@brands/store/selectors/oneReport';
import { selectVideoCallCredentials } from '@brands/store/selectors/videoCallCredentials';
import { setMedia } from '@brands/store/slices/oneReportSlice';
import { setUploadFileMethod } from '@brands/store/slices/videoCallCredentialsSlice';

import { completeCase } from '../../services/cases/completeCase';
import { getOneCase } from '../../services/cases/getCaseById';
import { defaultICaseValues } from '../../services/cases/types/defaultICaseValues';
import { CasePayload } from '../../services/cases/createNewCase';
import { CaseType, ICase, Status } from '../../services/cases/types/ICase';
import { RegisterMediaPayload } from '@brands/services/communication/registersConversationMedia';
import { createConversation } from '@brands/services/communication/createConversation';
import { addConversationParticipant } from '../../services/communication/addConversationParticipant';
import { getConversation } from '../../services/communication/getConversation';
import { addOneReportMedia } from '@brands/services/oneReport/addOneReportMedia';
import { addOneReportObject } from '@brands/services/oneReport/addOneReportObject';
import { addOneReportInternalNote } from '../../services/oneReport/addOneReportInternalNote';
import { confirmOneReportMedia } from '@brands/services/oneReport/confirmOneReportMedia';
import { getActiveVideoRoom } from '../../services/cases/getActiveVideoRoom';
import { getOneReportMedia } from '@brands/services/oneReport/getOneReportMedia';
import { registerOneReportMedia } from '@brands/services/oneReport/registerOneReportMedia';
import { updateOneReport } from '@brands/services/oneReport/updateOneReport';
import { ObjectType as updateOneReportObjectType } from '@brands/services/oneReport/updateOneReportObject';
import { IOneReport } from '../../services/oneReport/types/IOneReport';
import { IOneReportMedia } from '@brands/services/oneReport/types/IOneReportMedia';
import { editCaseType } from '@brands/services/cases/editCaseType';
import { getCaseJourneys } from '@brands/services/cases/multiStage';
import { MAX_JOURNEY_CASES } from '@brands/Dashboard/ConsultationPage/Components/AddFollowUpCareSection';
import { config } from '@brands/config/config';
import { listClinicalData } from '@brands/services/clinical_data/listClinicalData';
import { DentalHistory, MedicalConditions, MedicalHistory } from '@brands/services/clinical_data/types/types';
import {
  AttachmentNoteState,
  EnforceCAAssignModal,
  ImageNoteState,
  UnassignProviderModal,
} from '../../services/forms/types/ImageNote';
import { ImageWithNotes } from '../../services/forms/types/ImageWithNotes';
import { Insurance, UserRoleName } from '../../services/identity/types/UserProfile';

import { displayErrorDetails } from '../../Utils/displayError';
import { checkCollapsibleHeaderColor } from '../../Utils/getCollapsibleHeader';
import { getUploadFileMimeType } from '@brands/Utils/caseAttachmentFiles';

import GumLogo from '../../../gum-virtual-care/Dashboard/Appointments/assets/oHRLogo.svg';
import DefaultLogo from '../../../default/Dashboard/Appointments/assets/oHRLogo.svg';
import OHRPdfDocument from './Components/Documents/OHRPdfDocument/OHRPdfDocument';
import OHCPdfDocument from './Components/Documents/OHCPdfDocument/OHCPdfDocument';
import ComplianceChecklistModal, {
  ComplianceFormValues,
} from './Modals/ComplianceChecklistModal/ComplianceChecklistModal';
import OHRReviewDialog from './Modals/OHRReviewDialog/OHRReviewDialog';
import ImageNotesModal from './Modals/ImageNotesModal/ImageNotesModal';
import RemoveOneReportImage from './Modals/RemoveOneReportImage/RemoveOneReportImage';
import RemoveOneReportAttachment from './Modals/RemoveOneReportAttachment/RemoveOneReportAttachment';
import InsuranceCardModal from './Modals/InsuranceCardModal/InsuranceCardModal';

import { MobileConsultationView, InCallParticipant, ActiveVideoRoomResponse } from './types/consultationPage.types';
import {
  convertSvgBase64ToPngBase64,
  getCasePatientParticipantIdentities,
  getConversationApiType,
  getConversationIncludeOptions,
  getConversationSidFromCase,
  getConversationTypeKey,
  getParticipantIdentityForConversation,
  svgToBase64,
} from './utils/consultationHelpers';
import {
  VIDEO_PARTICIPANT_PRESENCE_EVENT,
  VideoParticipantPresenceEventDetail,
  forgetDisconnectedVideoParticipants,
  getVideoParticipantKeysFromPresenceMessage,
  isDisconnectedVideoParticipant,
  rememberDisconnectedVideoParticipants,
} from './utils/videoRoomParticipants';
import { getConsultationReportFilename, isOralHealthCoachingReport } from './utils/reportDownload';
import styles from './styles.module.scss';
import CareTeamPanel from './Components/CareTeamPanel';
import PatientInfoPanel from './Components/PatientInfoPanel';
import CaseContentPanel from './Components/CaseContentPanel';
import ConsultationMobileLayout from './Components/ConsultationMobileLayout';
import ConsultationDesktopLayout from './Components/ConsultationDesktopLayout';
import ConsultationBackButton from './Components/ConsultationBackButton';
import { cancelCase } from '@brands/services/cases/cancelCase';
import ProviderListTable from '@brands/Dashboard/ConsultationPage/Modals/ProviderListModal/ProviderListTable';
import { getFriendlyName, getFriendlyRoleName } from '@brands/Utils/getFriendlyName';
import EnforceAssignCAModal from './Modals/EnforceAssignCAModal/EnforceAssignCAModal';
import { getUserAvatar } from '../../services/identity/getUserAvatar';

/**
 * The subset of an attachment row that report rendering needs. One Report
 * media and Oral Health Coaching attachments are different tables with
 * different id types, but the report only ever reads these fields.
 */
type SelectableReportMedia = {
  id?: string | number;
  media_id?: string;
  note?: string;
  is_selected?: boolean;
  created_at?: string;
};

const ConsultationPage = (): JSX.Element => {
  const roleNavigate = useRoleNavigate();
  const location = useLocation();
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const routeCaseId = useParams().caseId as string;
  const screenSize = useWindowSize();
  const isMobile = screenSize.width < 768;
  const dispatch = useAppDispatch();
  const { subscribe, unsubscribe } = useSubscribe();

  const { userInfo } = useAppSelector(selectAuth);
  const { isCollapsed: mainSidenavCollapsed } = useAppSelector(selectSidebarState);

  const isCollectorCaseView =
    userInfo.role.name === UserRoleName.Collector ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin;
  const isPatientFacingReport =
    userInfo.role.name === UserRoleName.Patient || userInfo.role.name === UserRoleName.Dependent;
  const { media } = useAppSelector(selectOneReport);
  const { is_visible: isVisible } = useAppSelector(selectVideoCallCredentials);

  const [mobileView, setMobileView] = useState<MobileConsultationView>('case');
  const [loading, setLoading] = useState(false);
  const [thisCase, setCase] = useState<ICase>(defaultICaseValues);
  const [consultationForm, setConsultationForm] = useState<OralHealthReportSubmit>(consultationFormDefaultValues);
  const [images, setImages] = useState<ImageWithNotes[]>([]);
  const [oHRImages, setOHRImages] = useState<ImageWithNotes[]>([]);
  const [medicalHistory, setMedicalHistory] = useState<MedicalHistory | null>(null);
  const [medicalCondition, setMedicalCondition] = useState<MedicalConditions | null>(null);
  const [dentalHistory, setDentalHistory] = useState<DentalHistory | null>(null);
  const [pharmacyAddress, setPharmacyAddress] = useState('');
  const [pharmacyPhoneNumber, setPharmacyPhoneNumber] = useState('');
  const [generatedPdfUrl, setGeneratedPdfUrl] = useState<string | null>(null);
  const [isComplianceOpen, setIsComplianceOpen] = useState(false);
  const [isOHRReviewOpen, setIsOHRReviewOpen] = useState(false);
  const [editingFulfillmentApproval, setEditingFulfillmentApproval] = useState<boolean | null>(false);
  const [journeyPaused, setJourneyPaused] = useState(false);
  const [journeyAtLimit, setJourneyAtLimit] = useState(false);
  const allowedRolesForCommentsToProvider = [
    UserRoleName.Provider,
    UserRoleName.CareAdvisor,
    UserRoleName.Admin,
    UserRoleName.SuperAdmin,
    UserRoleName.OrganizationAdmin,
  ];

  const [selectProvidersModal, setSelectProvidersModal] = useState(false);

  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [addRequiredField, setAddRequiredField] = useState(false);
  const [editImageNote, setEditImageNote] = useState<ImageNoteState>(editImageNoteDefaultValues);
  const [removeImage, setRemoveImage] = useState<ImageNoteState>(removeImageDefaultValues);
  const [removeAttachment, setRemoveAttachment] = useState<AttachmentNoteState>(removeAttachmentDefaultValues);
  const [showInCallSection, setShowInCallSection] = useState(false);
  const [inCallParticipants, setInCallParticipants] = useState<InCallParticipant[]>([]);
  const [insuranceImages, setInsuranceImages] = useState<string[]>([]);
  const [openInsuranceModal, setOpenInsuranceModal] = useState(false);
  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [collectorConvModal, setCollectorConvModal] = useState<{
    open: boolean;
    options: { sid: string | null; label: string; conversationType: string }[];
  }>({ open: false, options: [] });
  const [scroll, setScroll] = useState(false);
  const [pdfLogo, setPdfLogo] = useState<string>();

  const pollingRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const icoreTimeout = useRef<NodeJS.Timeout | null>(null);
  const prevScrollTop = useRef(0);
  const isRefreshingCaseRef = useRef(false);
  // Guards `submitToPatient` against re-entry. The Submit button has
  // no disabled-while-submitting gate, and the page-level `loading`
  // overlay only kicks in once `setLoading(true)` re-renders — *after*
  // React batches the state update. Two rapid clicks both make it past
  // the guard and fire `completeCase` twice; the first wins, the
  // second comes back with "[10102-2] Case already completed" and
  // `displayErrorDetails` raises a toast even though the case is in
  // fact completed. A sync ref short-circuits the second call before
  // it ever issues the request.
  const isSubmittingRef = useRef(false);

  const params = useMemo(() => ({ sort_by: 'created_at' as const, sort_direction: 'desc' as const }), []);
  const { assignToProvider, assignToCareAdvisor, editCase, rescheduleCase, editCaseTypeFn } = useCases(
    params,
    true,
    userInfo.role.name,
  );

  useEffect(() => {
    if (!config.features.multiStage) return undefined;

    const patientId = thisCase.patient_id;
    if (!patientId) return undefined;

    let active = true;

    (async (): Promise<void> => {
      try {
        const { multi_stage: multiStage } = await getCaseJourneys(patientId);
        const journey = multiStage.find((g) => g.cases.some((c) => Number(c.id) === Number(thisCase.id)));
        if (active) {
          setJourneyPaused(journey?.status === 'paused');
          setJourneyAtLimit((journey?.cases.length || 0) >= MAX_JOURNEY_CASES);
        }
      } catch {}
    })();

    return () => {
      active = false;
    };
  }, [thisCase.id, thisCase.patient_id, thisCase.type]);

  const secondaryInsurance = thisCase.insurance ? thisCase?.second_insurance : undefined;

  const backPath = sessionStorage.getItem('lastNonConsultationPagePath') || '/';
  const shouldHideInCallSection = isVisible;

  const allowProviderUpdate =
    (userInfo.role.name === UserRoleName.Provider &&
      (thisCase.status === Status.InProgressProvider || thisCase.status === Status.AcceptedProvider) &&
      Number(thisCase.provider_id) === Number(userInfo.id)) ||
    (userInfo.role.name === UserRoleName.CareAdvisor &&
      (thisCase.type === CaseType.oral_health_coaching || thisCase.type === CaseType.care_coordination) &&
      Number(thisCase.care_advisor_id) === Number(userInfo.id));
  const allowAttachmentUpdate =
    allowProviderUpdate ||
    ([UserRoleName.Admin, UserRoleName.SuperAdmin, UserRoleName.OrganizationAdmin].includes(userInfo.role.name) &&
      [CaseType.oral_health_coaching, CaseType.care_coordination].includes(thisCase.type) &&
      thisCase.status !== Status.Completed &&
      thisCase.status !== Status.Canceled);
  const [enforceCaAssignmentModal, setEnforceCaAssignmentModal] = useState<EnforceCAAssignModal>({
    isOpen: false,
    caId: 0,
  });

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    reset,
    formState: { errors },
  } = useForm<OralHealthReportSubmit>({
    mode: 'onSubmit',
    defaultValues: consultationFormDefaultValues,
    resolver: yupResolver(
      validationSchema(userInfo, thisCase, addRequiredField, editingFulfillmentApproval, journeyPaused, journeyAtLimit),
    ),
  });

  const saveCaseCDT = async (caseCDT: string[]): Promise<void> => {
    setLoading(true);
    const { cdts: res } = await updateOneReport(
      thisCase?.one_report.id || '',
      {
        cdts:
          caseCDT.length > 0
            ? caseCDT
            : thisCase?.type === 'video_call_scheduled' ||
              thisCase?.type === 'video_call_instant' ||
              thisCase?.type === CaseType.phone_call_scheduled
            ? ['D9995']
            : ['D9996'],
      },
      userInfo.role.name,
    );
    setConsultationForm({
      ...consultationForm,
      cdt: res.map((currentCDT) => currentCDT.code),
    });
    setCase({
      ...thisCase,
      one_report: {
        ...thisCase.one_report,
        cdts: res,
      },
    });
    setLoading(false);
  };

  const changeCaseType = async (selectedCaseType: string): Promise<void> => {
    const payload: CasePayload = { type: selectedCaseType };

    if (typeof thisCase?.id === 'number' && selectedCaseType !== '') {
      try {
        setLoading(true);

        // 1. Update the case type
        const updatedCase = await editCaseTypeFn(thisCase.id, payload, userInfo.role.name);
        if (!updatedCase) return;

        // 2. Prepare CDT codes
        const currentCDTs = updatedCase.one_report.cdts || [];

        const newCDTs = currentCDTs.map((cdt) => {
          if (cdt.code === 'D9995') {
            // If new case type is phone/video call, keep D9995, otherwise replace with D9996
            if (
              selectedCaseType === 'video_call_scheduled' ||
              selectedCaseType === 'video_call_instant' ||
              selectedCaseType === 'phone_call_scheduled'
            ) {
              return cdt; // keep D9995
            }
            return { ...cdt, code: 'D9996', nomenclature: 'teledentistry – asynchronous; store-and-forward' };
          }

          if (cdt.code === 'D9996') {
            // If new case type is phone/video call, replace with D9995
            if (
              selectedCaseType === 'video_call_scheduled' ||
              selectedCaseType === 'video_call_instant' ||
              selectedCaseType === 'phone_call_scheduled'
            ) {
              return { ...cdt, code: 'D9995', nomenclature: 'teledentistry – synchronous; real-time encounter' };
            }
            return cdt; // keep D9996
          }

          // Keep other CDT codes unchanged
          return cdt;
        });

        // 3. Save updated CDTs
        await saveCaseCDT(newCDTs.map((item) => item.code));

        // 4. Update state
        setCase({
          ...updatedCase,
          type: updatedCase.type,
          updated_at: updatedCase.updated_at,
          started_at: updatedCase.started_at,
          video_conference_date: updatedCase.video_conference_date,
          one_report: {
            ...updatedCase.one_report,
            cdts: newCDTs,
          },
        });
      } catch (error: unknown) {
        displayErrorDetails(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const syncCompletedCase = async (fallbackCase?: ICase): Promise<boolean> => {
    if (fallbackCase) {
      setCase((currentCase) => ({ ...currentCase, ...fallbackCase, status: Status.Completed }));
    }

    try {
      const latestCase = await getOneCase(thisCase.id, {
        userRoleName: userInfo.role.name,
        include_patient_care_advisor_conversation: false,
        include_patient_provider_conversation: false,
        include_provider_care_advisor_conversation: false,
      });

      if (latestCase.status === Status.Completed) {
        setCase((currentCase) => ({ ...currentCase, ...latestCase }));
        return true;
      }
    } catch {
      // The completion response is still a safe fallback if refreshing fails.
    }

    return Boolean(fallbackCase);
  };

  const changeCaseStatus = async (
    status: 'completed' | 'canceled',
    reason?: string,
    reasonOther?: string,
  ): Promise<void> => {
    try {
      let updatedCase: ICase;

      if (status === 'canceled') {
        // Backend (cases/cancel_case.py) requires `reason_other` to be
        // present and non-empty when `reason_code === "OTHER"`. The
        // CaseDetailsCard cancel flow now collects it via the
        // SmallSelectionModal extra-text input and passes it through.
        updatedCase = await cancelCase(
          thisCase.id,
          {
            reason_code: reason,
            reason_other: reason === 'OTHER' ? reasonOther : undefined,
          },
          userInfo.role.name,
        );
      } else {
        updatedCase = await completeCase(thisCase.id, userInfo.role.name);
        await syncCompletedCase(updatedCase);
        return;
      }

      setCase(updatedCase);
    } catch (error: unknown) {
      if (status === 'completed' && (await syncCompletedCase())) return;
      displayErrorDetails(error);
    }
  };

  const displayPhoneNumber = useMemo(() => {
    try {
      if (thisCase?.patient?.phone_number) {
        const phoneNumber = parsePhoneNumber(thisCase.patient.phone_number, 'US');
        return phoneNumber?.formatNational() || '';
      }

      if (thisCase?.patient?.guardian?.phone_number) {
        const phoneNumber = parsePhoneNumber(thisCase.patient.guardian.phone_number, 'US');
        return phoneNumber?.formatNational() || '';
      }
    } catch (error) {
      return '';
    }

    return '';
  }, [thisCase]);

  async function handleReassignProvider(value: string): Promise<void> {
    if (!value) return;

    try {
      setLoading(true);

      const updatedCase = await assignToProvider(thisCase.id, {
        provider_id: Number(value),
      });

      if (!updatedCase) return;

      setCase((prev) => ({
        ...prev,
        status: updatedCase.status,
        provider: updatedCase.provider,
        provider_id: updatedCase.provider_id,
        updated_at: updatedCase.updated_at,
      }));
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  }

  async function handleReassignCareAdvisor(value: string): Promise<void> {
    if (!value) return;

    try {
      setLoading(true);
      if (thisCase.care_advisor_id === null) {
        const updatedCase = await assignToCareAdvisor(
          thisCase?.id,
          { care_advisor_id: Number(value), enforce_assignment: true },
          true,
        );
        if (updatedCase) {
          setCase({
            ...thisCase,
            status: updatedCase.status,
            care_advisor: updatedCase.care_advisor,
            care_advisor_id: updatedCase.care_advisor_id,
            updated_at: updatedCase.updated_at,
          });
          await refreshthisCase(true);
        }
      } else {
        setEnforceCaAssignmentModal({
          isOpen: true,
          caId: Number(value),
        });
      }
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  }

  const displayPharmacyPhoneNumber = (pharmacyPhoneNum: string): string => {
    if (!pharmacyPhoneNum) return '';
    try {
      const phoneNumber = parsePhoneNumber(pharmacyPhoneNum, 'US');
      return phoneNumber?.formatNational() || '';
    } catch (error) {
      return '';
    }
  };

  const handleScroll = (event: React.UIEvent<HTMLDivElement>): void => {
    const currentScrollTop = event.currentTarget.scrollTop;
    setScroll(currentScrollTop > prevScrollTop.current);
    prevScrollTop.current = currentScrollTop;
  };

  const handleMessageFromIcore = (event: MessageEvent): void => {
    if (event.data.result?.status === 'Complete') {
      if (icoreTimeout.current) {
        clearTimeout(icoreTimeout.current);
        icoreTimeout.current = null;
      }

      toast.success('Subscriptions added successfully.', { autoClose: 3000 });
    }
  };
  const getParticipantRoleLabel = useCallback(
    (participantId: number | string, roleName?: string) => {
      // For dependent cases the guardian (guardian_id) joins on the dependent's behalf
      const patientIdentity = thisCase?.patient?.guardian_id ?? thisCase?.patient?.id;
      if (Number(participantId) === Number(patientIdentity)) return 'Patient';
      return roleName ? getFriendlyRoleName(roleName) : '';
    },
    [thisCase],
  );

  const loadRoom = useCallback(async () => {
    if (!thisCase?.id || !userInfo?.id) return;
    const canClientAdminJoin =
      userInfo.role.name === UserRoleName.OrganizationAdmin &&
      userInfo?.organizations?.filter((f) => f.id == thisCase.organization.id).length !== 0;
    const isCaseParticipant =
      Number(userInfo.id) === Number(thisCase.provider_id) ||
      Number(userInfo.id) === Number(thisCase.care_advisor_id) ||
      Number(userInfo.id) === Number(thisCase.collector_id);
    if (!(isCaseParticipant || canClientAdminJoin)) return;

    try {
      const room: ActiveVideoRoomResponse = await getActiveVideoRoom(thisCase.id, userInfo.role.name);

      if (!room?.participants?.length) {
        setInCallParticipants([]);
        setShowInCallSection(true);
        return;
      }

      const connectedParticipantsWithoutMe = room.participants.filter(
        (participant) =>
          String(participant.identity) !== String(userInfo.id) &&
          participant.status === 'connected' &&
          !participant.end_time &&
          !isDisconnectedVideoParticipant(thisCase.id, participant, thisCase),
      );

      if (!connectedParticipantsWithoutMe.length) {
        setInCallParticipants([]);
        setShowInCallSection(true);
        return;
      }

      // Deduplicate by identity — guards against the same user appearing twice (e.g. after a reconnect)
      const seenIdentities = new Set<string>();
      const dedupedParticipants = connectedParticipantsWithoutMe.filter((p) => {
        const key = String(p.identity);
        if (seenIdentities.has(key)) return false;
        seenIdentities.add(key);
        return true;
      });

      // For dependent cases the guardian (guardian_id) joins on the dependent's behalf.
      // The backend may include a participant entry for the dependent (patient.id) even though
      // they cannot log in — exclude it so only the guardian appears as the patient.
      const isDependent = !!thisCase?.patient?.guardian_id;
      const uniqueParticipants = isDependent
        ? dedupedParticipants.filter((p) => String(p.identity) !== String(thisCase?.patient?.id))
        : dedupedParticipants;

      const mappedParticipants: InCallParticipant[] = uniqueParticipants.map((participant) => {
        const isPatient =
          Number(participant.identity) === Number(thisCase?.patient?.guardian_id ?? thisCase?.patient?.id);
        const displayName = isPatient
          ? thisCase?.patient?.full_name || participant.friendly_name
          : participant.user?.full_name || participant.friendly_name;
        return {
          id: participant.identity,
          name: displayName,
          role: getParticipantRoleLabel(participant.identity, participant.user?.role?.name),
          avatar: getUserAvatar(participant.user?.id || Number(participant.identity)),
          duration: Number(participant.duration || 0),
        };
      });

      setInCallParticipants(mappedParticipants);
      setShowInCallSection(true);
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        setInCallParticipants([]);
        setShowInCallSection(true);
        return;
      }

      console.error('Failed to fetch active video room', error);
    }
  }, [thisCase, userInfo?.id, userInfo.role.name, getParticipantRoleLabel]);

  const loadSelectedReportImages = useCallback(
    async (reportMedia?: SelectableReportMedia[] | null): Promise<ImageWithNotes[]> => {
      if (!reportMedia?.length) return [];

      const imagePromises = reportMedia
        .filter((mediaOneReport) => mediaOneReport.is_selected)
        .map(async (mediaOneReport: SelectableReportMedia) => {
          const mediaData = await getOneReportMedia(mediaOneReport.media_id!, userInfo.role.name);
          if (!mediaData?.url) return null;

          return {
            src: mediaData.url,
            width: 4,
            height: 3,
            filename: mediaData.filename,
            mimetype: mediaData.mimetype,
            notes: mediaOneReport.note,
            id: String(mediaOneReport.id),
            isSelected: mediaOneReport.is_selected,
            created_at: mediaOneReport.created_at,
          };
        });

      const loadedImages = (await Promise.all(imagePromises)).filter(Boolean);
      return loadedImages as ImageWithNotes[];
    },
    [userInfo.role.name],
  );

  /**
   * The attachments a report shows the patient.
   *
   * Oral Health Coaching cases keep theirs on the report rather than on
   * `one_report`, which they do not have — reading only `one_report`
   * left their PDF permanently empty.
   */
  const selectedMediaForCase = useCallback(
    (someCase: ICase): SelectableReportMedia[] =>
      someCase.type === CaseType.oral_health_coaching
        ? someCase.oral_health_coaching_report?.media || []
        : someCase.one_report?.media || [],
    [],
  );

  const loadImages = useCallback(async (): Promise<void> => {
    try {
      setOHRImages(await loadSelectedReportImages(selectedMediaForCase(thisCase)));
    } catch (error) {
      console.error('Error loading images:', error);
      setOHRImages([]);
    }
  }, [loadSelectedReportImages, selectedMediaForCase, thisCase]);

  const updateSelectedImages = useCallback(
    (updatedReport: IOneReport): void => {
      const selectedImages = updatedReport?.media?.filter((image) => image.is_selected);
      setValue('selectedImages', selectedImages, { shouldValidate: !!errors?.selectedImages });
      setConsultationForm((prev) => ({ ...prev, selectedImages }));
    },
    [errors?.selectedImages, setValue],
  );

  const accept = async (checked: boolean): Promise<void> => {
    if (!thisCase?.one_report?.id) return;
    await updateOneReport(thisCase.one_report.id, { is_terms_accepted: checked }, userInfo.role.name);
  };

  const thisCaseRef = useRef(thisCase);

  useEffect(() => {
    thisCaseRef.current = thisCase;
  }, [thisCase]);

  const refreshthisCase = useCallback(
    async (initialCaseRefresh: boolean): Promise<void> => {
      if (isRefreshingCaseRef.current) return;

      isRefreshingCaseRef.current = true;
      const shouldShowPageLoader = initialCaseRefresh || !thisCaseRef.current?.id;

      if (shouldShowPageLoader) {
        setLoading(true);
      }

      try {
        const res = await getOneCase(Number(routeCaseId), {
          userRoleName: userInfo.role.name,
          include_patient_care_advisor_conversation: true,
          include_patient_provider_conversation: true,
          include_provider_care_advisor_conversation: true,
        });

        if (!res) return;

        const currentCase = thisCaseRef.current;

        const reportUpdated =
          res.one_report?.updated_at !== currentCase.one_report?.updated_at ||
          res.care_coordination_report?.updated_at !== currentCase.care_coordination_report?.updated_at ||
          res.oral_health_coaching_report?.updated_at !== currentCase.oral_health_coaching_report?.updated_at;

        const userUpdated =
          res.patient?.updated_at !== currentCase.patient?.updated_at ||
          res.patient?.guardian?.updated_at !== currentCase.patient?.guardian?.updated_at ||
          res.provider?.updated_at !== currentCase.provider?.updated_at ||
          res.care_advisor?.updated_at !== currentCase.care_advisor?.updated_at ||
          res.collector?.updated_at !== currentCase.collector?.updated_at;

        const shouldUpdate =
          initialCaseRefresh ||
          res.status !== currentCase.status ||
          res.type !== currentCase.type ||
          res.due_date !== currentCase.due_date ||
          res.video_conference_date !== currentCase.video_conference_date ||
          res.care_advisor_id !== currentCase.care_advisor_id ||
          res.provider_id !== currentCase.provider_id ||
          reportUpdated ||
          userUpdated;
        if (!shouldUpdate) return;

        let newUpdatedCase = null;
        let followUpRes = null;

        if (
          userInfo.role.name === UserRoleName.CareAdvisor &&
          Number(res.care_advisor_id) === Number(userInfo.id) &&
          (res.type === CaseType.care_coordination || res.type === CaseType.oral_health_coaching) &&
          res.status === Status.AcceptedCareAdvisor
        ) {
          const payload: CasePayload = {
            status: Status.InProgressCareAdvisor,
          };

          newUpdatedCase = await editCase(res.id, payload);
        }

        if (
          userInfo.role.name === UserRoleName.Provider &&
          res.status === Status.AcceptedProvider &&
          Number(userInfo.id) === Number(res.provider_id)
        ) {
          newUpdatedCase = await editCase(res.id, { status: Status.InProgressProvider } as CasePayload);
        }

        if (
          userInfo.role.name === UserRoleName.Provider &&
          Number(res.provider_id) === Number(userInfo.id) &&
          (res.status === Status.InProgressProvider || res.status === Status.AcceptedProvider) &&
          res.type !== CaseType.oral_health_coaching &&
          res.type !== CaseType.care_coordination &&
          res.one_report?.follow_ups === null
        ) {
          [followUpRes] = await Promise.all([
            addOneReportObject(res.one_report.id || '', updateOneReportObjectType.FollowUp, {
              care_coordination: false,
              oral_health_coaching: false,
              care_coordination_type: 'DO-2870',
              care_coordination_urgency: '',
              care_coordination_reason: '',
              oral_health_coaching_type: 'DO-2870',
              oral_health_coaching_urgency: '',
              oral_health_coaching_reason: '',
            }),
          ]);
        }

        setCase({
          ...res,
          status: newUpdatedCase ? (newUpdatedCase.status as Status) : res.status,
          one_report: {
            ...res.one_report,
            ...(followUpRes && { follow_ups: followUpRes.follow_ups }),
          },
        });

        if (res.type !== CaseType.care_coordination && res.type !== CaseType.oral_health_coaching) {
          setConsultationForm((prev) => ({
            ...prev,
            is_terms_accepted: res.one_report?.is_terms_accepted || false,
            assessment: res.one_report?.assessments || '',
            cdt: res.one_report?.cdts?.map((cdt) => cdt.code) || [],
            subjective: {
              chief_complaint_problem: res.one_report?.chief_complaint_problem || '',
              medical_history: res.one_report?.medical_history || '',
              pain_scale: res.one_report?.pain_scale?.toString(),
            },
            objective: {
              is_media_utilized:
                res.one_report?.is_media_utilized === true
                  ? 'Utilized'
                  : res.one_report?.is_media_utilized === false
                  ? 'Not utilized'
                  : '',
              is_intra_oral_utilized:
                res.one_report?.is_intra_oral_utilized === true
                  ? 'Visualized'
                  : res.one_report?.is_intra_oral_utilized === false
                  ? 'Not visualized'
                  : '',
              is_extra_oral_utilized:
                res.one_report?.is_extra_oral_utilized === true
                  ? 'Visualized'
                  : res.one_report?.is_extra_oral_utilized === false
                  ? 'Not visualized'
                  : '',
            },

            plan: {
              disposition: res.one_report?.disposition || '',
              prescription_in_icore: res.one_report?.prescription_in_icore,
              pharmacy: res.one_report?.pharmacy,
              need_for_oral_health_coaching: res.one_report?.need_for_oral_health_coaching,
            },
            educations:
              res?.one_report.educations.length > 0
                ? res?.one_report?.educations
                    ?.map((education) => ({
                      url: education.url,
                      title: education.title,
                      id: education.id,
                    }))
                    .sort((a, b) => Number(a.id) - Number(b.id))
                : [],
            followUp: followUpRes ? followUpRes?.follow_ups : res?.one_report?.follow_ups || [],

            prescriptions:
              res?.one_report?.prescriptions?.map((prescription) => ({
                drug: prescription.drug || '',
                sig: prescription.sig || '',
                prescription_date: prescription.prescription_date || '',
                dispense: prescription.dispense || '',
                refills: prescription.refills || '',
                id: prescription.id,
                created_at: prescription.created_at || '',
                pharmacy: {
                  pharmacy_name: prescription?.pharmacy?.pharmacy_name || '',
                  pharmacy_street_address: prescription?.pharmacy?.pharmacy_street_address || '',
                  pharmacy_city: prescription?.pharmacy?.pharmacy_city || '',
                  pharmacy_state: prescription?.pharmacy?.pharmacy_state || '',
                  pharmacy_zip_code: prescription?.pharmacy?.pharmacy_zip_code || '',
                  pharmacy_phone_number: prescription?.pharmacy?.pharmacy_phone_number || '',
                },
              })) || [],
            pharmacies: res.one_report?.pharmacies,
            pharmacy_name: res?.medical_history_snapshot?.pharmacy_name ?? '',
            pharmacy_street_address: res?.medical_history_snapshot?.pharmacy_street_address ?? '',
            pharmacy_city: res?.medical_history_snapshot?.pharmacy_city ?? '',
            pharmacy_state: res?.medical_history_snapshot?.pharmacy_state ?? '',
            pharmacy_zip_code: res?.medical_history_snapshot?.pharmacy_zip_code ?? '',
            pharmacy_phone_number: res?.medical_history_snapshot?.pharmacy_phone_number ?? '',

            selectedImages: res.one_report?.media?.filter((image) => image.is_selected) || [],
            additionalPeople: res.video_conference_other_participants || '',
            isAdditionalPeople: !!res.video_conference_other_participants,
          }));
        } else if (res.type === CaseType.care_coordination) {
          setConsultationForm((prev) => ({
            ...prev,
            internal_note:
              localStorage.getItem('internal_note') !== null &&
              res.id in JSON.parse(localStorage.getItem('internal_note')!)
                ? JSON.parse(localStorage.getItem('internal_note')!)[res.id]
                : '',
            benefits_navigation:
              localStorage.getItem('benefits_navigation') !== null &&
              res.id in JSON.parse(localStorage.getItem('benefits_navigation')!)
                ? JSON.parse(localStorage.getItem('benefits_navigation')!)[res.id]
                : '',
            note:
              localStorage.getItem('note') !== null && res.id in JSON.parse(localStorage.getItem('note')!)
                ? JSON.parse(localStorage.getItem('note')!)[res.id]
                : '',
          }));
        } else if (res.type === CaseType.oral_health_coaching) {
          setConsultationForm((prev) => ({
            ...prev,
            oralHealthCoachingInternalNote:
              localStorage.getItem('OHC_internal_note') !== null &&
              res.id in JSON.parse(localStorage.getItem('OHC_internal_note')!)
                ? JSON.parse(localStorage.getItem('OHC_internal_note')!)[res.id]
                : '',
            care_plan: res.oral_health_coaching_report?.care_plan,
            education: [],
            goal: res.oral_health_coaching_report?.care_plan?.goals,
          }));
        }
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 403 && userInfo.role.name === UserRoleName.Provider) {
          roleNavigate('/dashboard');
          return;
        }
        displayErrorDetails(error);
      } finally {
        if (shouldShowPageLoader) {
          setLoading(false);
        }
        isRefreshingCaseRef.current = false;
      }
    },
    [editCase, routeCaseId, userInfo, roleNavigate],
  );

  const changeCaseUnreadIndicator = async (): Promise<void> => {
    try {
      const updatedCase = await getOneCase(thisCase.id, {
        userRoleName: userInfo.role.name,
        include_patient_care_advisor_conversation: true,
        include_patient_provider_conversation: true,
        include_provider_care_advisor_conversation: userInfo.role.name !== UserRoleName.Patient,
      });

      if (!updatedCase) return;

      setCase((prev) => ({
        ...prev,
        patient_care_advisor_conversation_stats: updatedCase.patient_care_advisor_conversation_stats,
        patient_provider_conversation_stats: updatedCase.patient_provider_conversation_stats,
        provider_care_advisor_conversation_stats: updatedCase.provider_care_advisor_conversation_stats,
      }));
    } catch (error) {
      displayErrorDetails(error);
    }
  };

  const updateCaseForAdditionalInfoAndImages = async (): Promise<void> => {
    try {
      const updatedCase = await getOneCase(thisCase.id, {
        userRoleName: userInfo.role.name,
        include_patient_care_advisor_conversation: false,
        include_patient_provider_conversation: false,
        include_provider_care_advisor_conversation: false,
      });

      if (!updatedCase) return;

      setCase((prev) => ({
        ...prev,
        case_intake_questions: {
          ...prev.case_intake_questions,
          additional_info: updatedCase.case_intake_questions?.additional_info,
        },
        one_report: {
          ...prev.one_report,
          media: updatedCase.one_report?.media,
        },
      }));
    } catch (error) {
      displayErrorDetails(error);
    }
  };

  const removeDisconnectedInCallParticipants = useCallback(
    (participantIdentities: string[]): void => {
      const disconnectedKeys = new Set(participantIdentities.map(String));

      setInCallParticipants((participants) =>
        participants.filter((participant) => {
          const participantKeys: unknown[] = [participant.id];

          switch (participant.role) {
            case getFriendlyRoleName(UserRoleName.Provider):
              participantKeys.push(thisCase.provider_id, thisCase.provider?.id);
              break;
            case getFriendlyRoleName(UserRoleName.CareAdvisor):
              participantKeys.push(thisCase.care_advisor_id, thisCase.care_advisor?.id);
              break;
            case getFriendlyRoleName(UserRoleName.Collector):
              participantKeys.push(thisCase.collector_id, thisCase.collector?.id);
              break;
            case 'Patient':
              participantKeys.push(thisCase.patient?.guardian_id, thisCase.patient_id, thisCase.patient?.id);
              break;
            default:
              break;
          }

          return !participantKeys.some((participantKey) => disconnectedKeys.has(String(participantKey)));
        }),
      );
    },
    [thisCase],
  );

  const onMessage = useCallback(
    (message: Record<string, any>) => {
      if (Number(message.case_id) !== Number(thisCase.id)) return;

      if (message.command === 'case_new_message_created') {
        if (thisCase && !isEqual(thisCase, defaultICaseValues)) {
          void changeCaseUnreadIndicator();
        }
        return;
      }

      if (message.command === 'case_add_additional_info') {
        void updateCaseForAdditionalInfoAndImages();
        return;
      }

      if (['participant_connected', 'participant_disconnected'].includes(message.command)) {
        const participantIdentities = getVideoParticipantKeysFromPresenceMessage(message, thisCase);

        if (message.command === 'participant_connected') {
          forgetDisconnectedVideoParticipants(thisCase.id, participantIdentities);
          void loadRoom();
          return;
        }

        if (message.command === 'participant_disconnected') {
          if (participantIdentities.length) {
            rememberDisconnectedVideoParticipants(thisCase.id, participantIdentities);
            removeDisconnectedInCallParticipants(participantIdentities);

            void loadRoom();
          } else {
            setInCallParticipants([]);
          }

          setShowInCallSection(true);
          return;
        }
      }

      if (['case_cancelled', 'case_updated'].includes(message.command)) {
        void refreshthisCase(false);
      }
    },
    [loadRoom, refreshthisCase, removeDisconnectedInCallParticipants, thisCase],
  );

  const onVideoParticipantPresenceEvent = useCallback(
    (event: Event) => {
      const detail = (event as CustomEvent<VideoParticipantPresenceEventDetail>).detail;

      if (!detail || Number(detail.caseId) !== Number(thisCase.id)) return;

      const participantIdentities = (detail.participantIdentities || []).map(String);

      if (detail.command === 'participant_connected') {
        forgetDisconnectedVideoParticipants(thisCase.id, participantIdentities);
        void loadRoom();
        return;
      }

      if (participantIdentities.length) {
        rememberDisconnectedVideoParticipants(thisCase.id, participantIdentities);
        removeDisconnectedInCallParticipants(participantIdentities);

        void loadRoom();
      } else {
        setInCallParticipants([]);
      }

      setShowInCallSection(true);
    },
    [loadRoom, removeDisconnectedInCallParticipants, thisCase.id],
  );

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage,
      commands: [
        'case_new_message_created',
        'case_add_additional_info',
        'case_cancelled',
        'case_updated',
        'participant_connected',
        'participant_disconnected',
      ],
    }),
    [onMessage],
  );

  const uploadFile = useCallback(
    async (file: File): Promise<void> => {
      if (!allowAttachmentUpdate || !thisCase.one_report?.id) return;

      const mimetype = getUploadFileMimeType(file);
      const payload: RegisterMediaPayload = {
        files: [{ filename: file.name, mimetype }],
      };

      try {
        const res = await registerOneReportMedia(payload, userInfo.role.name);
        const mediaId = res.files[0].upload_id;

        await fetch(res.files[0].upload_url, {
          method: 'PUT',
          body: file,
          headers: { 'content-type': mimetype },
        });

        await confirmOneReportMedia(mediaId, userInfo.role.name);

        dispatch(
          setMedia([
            ...(media as IOneReportMedia[]),
            {
              media_id: mediaId,
              note: '',
            },
          ]),
        );

        const updatedOneReport = await addOneReportMedia(
          thisCase.one_report.id,
          {
            media_id: mediaId,
            note: '',
          },
          userInfo.role.name,
        );

        setCase((prev) => ({ ...prev, one_report: updatedOneReport }));
        updateSelectedImages(updatedOneReport);
      } catch (error) {
        displayErrorDetails(error);
      }
    },
    [allowAttachmentUpdate, dispatch, media, thisCase.one_report?.id, updateSelectedImages, userInfo.role.name],
  );

  const addPhoto = (event: React.ChangeEvent<HTMLInputElement>): void => {
    event.preventDefault();
    const { files } = event.currentTarget;
    if (!files) return;

    setUploadingPhoto(true);

    const processFiles = Array.from(files).map(async (file) => {
      if (file.type !== 'image/heic') return file;

      try {
        const jpegBlob = await heicTo({
          blob: file,
          type: 'image/jpeg',
          quality: 0.85,
        });

        return new File([jpegBlob], file.name.replace(/\.heic$/i, '.jpeg'), {
          type: 'image/jpeg',
        });
      } catch (error: any) {
        toast.error(`Error converting HEIC file: ${error.message}`);
        return file;
      }
    });

    Promise.all(processFiles)
      .then((convertedFiles) => Promise.all(convertedFiles.map(uploadFile)))
      .catch((error) => {
        toast.error(`Error processing files: ${error.message}`);
      })
      .finally(() => {
        setUploadingPhoto(false);
      });
  };

  const getFormAnswers = useCallback(async (patientId: number): Promise<void> => {
    try {
      const { medical_history, medical_conditions, dental_history } = await listClinicalData(patientId);
      setMedicalHistory(medical_history);
      setMedicalCondition(medical_conditions);
      setDentalHistory(dental_history);
      setPharmacyAddress(
        [
          medical_history?.pharmacy_street_address,
          medical_history?.pharmacy_city,
          medical_history?.pharmacy_state,
          medical_history?.pharmacy_zip_code,
        ]
          .filter(Boolean)
          .join(', '),
      );
      setPharmacyPhoneNumber(displayPharmacyPhoneNumber(medical_history?.pharmacy_phone_number || ''));
    } catch (error) {
      toast.error(`Error fetching form answers: ${error}`);
    }
  }, []);

  const onSubmit = async (data: OralHealthReportSubmit): Promise<void> => {
    try {
      setLoading(true);

      setConsultationForm(data);

      const updatedCase = await getOneCase(Number(routeCaseId), {
        userRoleName: userInfo.role.name,
        include_patient_care_advisor_conversation: false,
        include_patient_provider_conversation: false,
        include_provider_care_advisor_conversation: false,
      });

      if (!updatedCase) return;

      setCase(updatedCase);

      const shouldOpenCompliance =
        thisCase.type !== CaseType.care_coordination &&
        thisCase.type !== CaseType.oral_health_coaching &&
        [Status.InProgressCareAdvisor, Status.InProgressProvider, Status.AcceptedProvider].includes(updatedCase.status);

      if (shouldOpenCompliance) {
        setIsComplianceOpen(true);
      } else {
        await submitToPatient();
      }
    } catch (error) {
      console.error('onSubmit error:', error);
    } finally {
      setLoading(false);
    }
  };

  const onInvalid = (errorsList: any): void => {
    if (!errorsList) {
      toast.error('An unknown error occurred');
      return;
    }

    const findFirstMessage = (errorObj: any): string | null => {
      if (!errorObj || typeof errorObj !== 'object') return null;
      if (errorObj.message && typeof errorObj.message === 'string') return errorObj.message;

      for (const key of Object.keys(errorObj)) {
        const result = findFirstMessage(errorObj[key]);
        if (result) return result;
      }

      return null;
    };

    toast.error(findFirstMessage(errorsList) || 'An unknown error occurred');
  };

  const submitToPatient = async (): Promise<void> => {
    if (typeof thisCase?.id !== 'number') return;
    // Short-circuit re-entry from a double-click / double-fire of the
    // form submit. Without this guard a second call lands `completeCase`
    // again and the backend correctly rejects it with "[10102-2] Case
    // already completed", which the user sees as a misleading error
    // toast.
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    try {
      setLoading(true);
      const updatedCase = await completeCase(thisCase.id, userInfo.role.name);
      await syncCompletedCase(updatedCase);
      toast.success('Report sent to the patient.', { className: 'fs-unmask' });
    } catch (error) {
      if (await syncCompletedCase()) {
        toast.success('Report sent to the patient.', { className: 'fs-unmask' });
        return;
      }
      displayErrorDetails(error);
    } finally {
      setLoading(false);
      setIsOHRReviewOpen(false);
      isSubmittingRef.current = false;
    }
  };

  const generateOHRPdf = async (): Promise<void> => {
    const updatedCase = await getOneCase(Number(routeCaseId), {
      userRoleName: userInfo.role.name,
      include_patient_care_advisor_conversation: false,
      include_patient_provider_conversation: false,
      include_provider_care_advisor_conversation: false,
    });

    const reportImages = await loadSelectedReportImages(selectedMediaForCase(updatedCase));
    const isOHC = isOralHealthCoachingReport(updatedCase.type);
    const blob = await pdf(
      isOHC ? (
        <OHCPdfDocument thisCase={updatedCase} logoBase64={pdfLogo || ''} images={reportImages} />
      ) : (
        <OHRPdfDocument
          thisCase={updatedCase}
          logoBase64={pdfLogo || ''}
          images={reportImages}
          medicalHistory={medicalHistory}
          medicalCondition={medicalCondition}
          pharmacyAddress={pharmacyAddress}
          pharmacyPhoneNumber={pharmacyPhoneNumber}
          hideAttestationChecklistCopy={isPatientFacingReport}
        />
      ),
    ).toBlob();

    const url = URL.createObjectURL(blob);
    setGeneratedPdfUrl(url);
  };

  const downloadOHRPdf = async (): Promise<void> => {
    // Open a blank tab synchronously while still inside the user-gesture context.
    // window.open called after an await loses that context and is blocked by popup
    // blockers on iOS Safari, Android WebView, and most desktop browsers.
    const newTab = window.open('', '_blank');

    try {
      setLoading(true);
      const updatedCase = await getOneCase(Number(routeCaseId), {
        userRoleName: userInfo.role.name,
        include_patient_care_advisor_conversation: false,
        include_patient_provider_conversation: false,
        include_provider_care_advisor_conversation: false,
      });

      const reportImages = await loadSelectedReportImages(selectedMediaForCase(updatedCase));
      const isOHC = isOralHealthCoachingReport(updatedCase.type);
      const blob = await pdf(
        isOHC ? (
          <OHCPdfDocument thisCase={updatedCase} logoBase64={pdfLogo || ''} images={reportImages} />
        ) : (
          <OHRPdfDocument
            thisCase={updatedCase}
            logoBase64={pdfLogo || ''}
            images={reportImages}
            medicalHistory={medicalHistory}
            medicalCondition={medicalCondition}
            pharmacyAddress={pharmacyAddress}
            pharmacyPhoneNumber={pharmacyPhoneNumber}
            hideAttestationChecklistCopy={isPatientFacingReport}
          />
        ),
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const filename = getConsultationReportFilename(updatedCase.type);

      // Navigate the pre-opened tab to the PDF blob
      if (newTab) {
        newTab.location.href = url;
      } else {
        // Fallback: popup was blocked despite pre-open (rare); try again
        window.open(url, '_blank');
      }

      // Trigger a file download.
      // On iOS Safari the <a download> attribute is ignored for blob URLs —
      // the PDF is already visible in the tab above, so no additional action needed.
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setTimeout(() => URL.revokeObjectURL(url), 30000);
    } catch (error) {
      displayErrorDetails(error);
      newTab?.close();
    } finally {
      setLoading(false);
    }
  };

  const handleComplianceSubmit = async (data: ComplianceFormValues): Promise<void> => {
    try {
      setLoading(true);

      const updates: Promise<unknown>[] = [];
      const reasonText = data.reason === 'Other' ? data.otherReason : data.reason;
      const hasCaseTypeChanged = data.confirmCaseType !== thisCase.type;
      const hasAdditionalPeople = Boolean(data.additionalPeople?.length);

      if (hasCaseTypeChanged) {
        updates.push(editCaseType(thisCase.id, { type: data.confirmCaseType }, userInfo.role.name));

        updates.push(
          addOneReportInternalNote(
            thisCase.one_report.id || '',
            {
              note: `Case type was updated from ${getFriendlyName(thisCase.type)} to ${getFriendlyName(
                data.confirmCaseType,
              )}. Reason: ${reasonText}`,
            },
            userInfo.role.name,
          ),
        );
      }

      if (hasAdditionalPeople) {
        updates.push(
          editCase(thisCase.id, {
            video_conference_other_participants: data.additionalPeople,
          }),
        );
      }

      if (updates.length > 0) {
        await Promise.all(updates);
      }

      setIsComplianceOpen(false);
      await generateOHRPdf();
      setIsOHRReviewOpen(true);
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const createCaseConversation = async (
    caseData: ICase,
    conversationType: string,
    myRoleName: string,
  ): Promise<string | null> => {
    const buildParticipants = (): string[] => {
      if (myRoleName !== UserRoleName.Collector) {
        return getParticipantIdentityForConversation(conversationType, caseData, myRoleName);
      }

      const patientIdentities = getCasePatientParticipantIdentities(caseData);
      const careAdvisorIdentity = caseData.care_advisor_id ? String(caseData.care_advisor_id) : '';
      const providerIdentity = caseData.provider_id ? String(caseData.provider_id) : '';

      if (conversationType === `${UserRoleName.Patient}_${UserRoleName.CareAdvisor}`) {
        return [...patientIdentities, careAdvisorIdentity].filter(Boolean);
      }

      if (conversationType === `${UserRoleName.Provider}_${UserRoleName.CareAdvisor}`) {
        return [providerIdentity, careAdvisorIdentity].filter(Boolean);
      }

      if (conversationType === `${UserRoleName.Patient}_${UserRoleName.Provider}`) {
        return [...patientIdentities, providerIdentity].filter(Boolean);
      }

      throw new Error(`Unsupported conversation type: ${conversationType}`);
    };

    const participantIds = buildParticipants();

    const newConversation = await createConversation(
      {
        friendly_name: conversationType,
        participants: participantIds.map((identity) => ({ identity })),
        conversation_type: getConversationApiType(conversationType),
        case_id: Number(caseData.id),
        attributes: { case_id: Number(caseData.id) },
      },
      userInfo.role.name,
    );

    return newConversation?.sid ?? null;
  };

  const isAssigned =
    (userInfo.role.name === UserRoleName.Provider && Number(userInfo.id) === Number(thisCase.provider_id)) ||
    (userInfo.role.name === UserRoleName.CareAdvisor && Number(userInfo.id) === Number(thisCase.care_advisor_id)) ||
    (userInfo.role.name === UserRoleName.Collector && Number(userInfo.id) === Number(thisCase.collector_id));

  const openOrCreateConversation = async (myRoleName: string, withRoleName: string): Promise<void> => {
    try {
      if (!thisCase?.id) return;

      setLoading(true);

      const conversationType = getConversationTypeKey(myRoleName, withRoleName);

      if (!conversationType) {
        roleNavigate(`/case-chat/${thisCase.id}`);
        return;
      }

      const freshCase = await getOneCase(Number(thisCase.id), getConversationIncludeOptions(userInfo.role.name));

      let conversationSid = getConversationSidFromCase(freshCase, conversationType);

      if (!conversationSid && isAssigned) {
        conversationSid = await createCaseConversation(freshCase, conversationType, myRoleName);

        if (!conversationSid) {
          throw new Error('Conversation could not be created');
        }

        const updatedCase = await getOneCase(Number(thisCase.id), getConversationIncludeOptions(userInfo.role.name));
        setCase(updatedCase);
      } else {
        setCase(freshCase);
      }
      if (conversationSid) {
        roleNavigate(`/case-chat/${thisCase.id}/${conversationSid}`);
      } else {
        toast.error('No conversation found.');
      }
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const redirectToConversationPage = (myRoleName: string, withRoleName: string): void => {
    void openOrCreateConversation(myRoleName, withRoleName);
  };

  const joinOrCreateAndOpen = async (option: { sid: string | null; conversationType: string }): Promise<void> => {
    try {
      setLoading(true);
      let sid = option.sid;
      const isJoiningExisting = !!sid;

      if (!sid) {
        const freshCase = await getOneCase(Number(thisCase.id), getConversationIncludeOptions(userInfo.role.name));
        sid = getConversationSidFromCase(freshCase, option.conversationType);

        const isAssigned =
          (userInfo.role.name === UserRoleName.Provider && Number(userInfo.id) === Number(thisCase.provider_id)) ||
          (userInfo.role.name === UserRoleName.CareAdvisor &&
            Number(userInfo.id) === Number(thisCase.care_advisor_id)) ||
          (userInfo.role.name === UserRoleName.Collector && Number(userInfo.id) === Number(thisCase.collector_id));

        if (!sid && isAssigned) {
          sid = await createCaseConversation(freshCase, option.conversationType, userInfo.role.name);
          if (!sid) throw new Error('Conversation could not be created');
          const updatedCase = await getOneCase(Number(thisCase.id), getConversationIncludeOptions(userInfo.role.name));
          setCase(updatedCase);
        } else {
          setCase(freshCase);
        }
      }

      if (isJoiningExisting && userInfo.role.name === UserRoleName.Collector) {
        try {
          const conversation = await getConversation(sid, true, userInfo.role.name);
          const alreadyParticipant = conversation.participants?.some((p) => Number(p.identity) === Number(userInfo.id));
          if (!alreadyParticipant) {
            await addConversationParticipant({ identity: String(userInfo.id) }, sid, userInfo.role.name);
          }
        } catch (error) {
          displayErrorDetails(error);
          return;
        }
      }

      if (sid) {
        roleNavigate(`/case-chat/${thisCase.id}/${sid}`);
      } else {
        toast.error('No conversation found.');
      }
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCollectorMessageClick = async (withRole: string): Promise<void> => {
    if (!thisCase?.id) return;

    try {
      setLoading(true);

      const freshCase = await getOneCase(Number(thisCase.id), getConversationIncludeOptions(userInfo.role.name));
      setCase(freshCase);

      const options: { sid: string | null; label: string; conversationType: string }[] = [];

      if (withRole === UserRoleName.Provider) {
        options.push({
          sid: freshCase.patient_provider_conversation_sid ?? null,
          label: 'Patient ↔ Provider',
          conversationType: `${UserRoleName.Patient}_${UserRoleName.Provider}`,
        });
        if (freshCase.care_advisor_id) {
          options.push({
            sid: freshCase.provider_care_advisor_conversation_sid ?? null,
            label: 'Provider ↔ Care Advisor',
            conversationType: `${UserRoleName.Provider}_${UserRoleName.CareAdvisor}`,
          });
        }
      } else if (withRole === UserRoleName.CareAdvisor) {
        options.push({
          sid: freshCase.patient_care_advisor_conversation_sid ?? null,
          label: 'Patient ↔ Care Advisor',
          conversationType: `${UserRoleName.Patient}_${UserRoleName.CareAdvisor}`,
        });
        if (freshCase.provider_id) {
          options.push({
            sid: freshCase.provider_care_advisor_conversation_sid ?? null,
            label: 'Provider ↔ Care Advisor',
            conversationType: `${UserRoleName.Provider}_${UserRoleName.CareAdvisor}`,
          });
        }
      } else if (withRole === UserRoleName.Patient) {
        if (freshCase.provider_id) {
          options.push({
            sid: freshCase.patient_provider_conversation_sid ?? null,
            label: 'Patient ↔ Provider',
            conversationType: `${UserRoleName.Patient}_${UserRoleName.Provider}`,
          });
        }
        if (freshCase.care_advisor_id) {
          options.push({
            sid: freshCase.patient_care_advisor_conversation_sid ?? null,
            label: 'Patient ↔ Care Advisor',
            conversationType: `${UserRoleName.Patient}_${UserRoleName.CareAdvisor}`,
          });
        }
      }

      if (options.length === 0) return;
      if (options.length === 1) {
        void joinOrCreateAndOpen(options[0]);
        return;
      }

      setCollectorConvModal({ open: true, options });
    } catch (error) {
      displayErrorDetails(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenInsuranceCard = async (insurance?: Insurance): Promise<void> => {
    if (!insurance) return;

    try {
      setInsuranceLoading(true);
      setOpenInsuranceModal(true);
      setInsuranceImages([]);

      const mediaIds = [
        insurance.media?.find((item) => item.type === 'front_of_card')?.media_id,
        insurance.front_of_card?.[0]?.media_id,
        insurance.media?.find((item) => item.type === 'back_of_card')?.media_id,
        insurance.back_of_card?.[0]?.media_id,
      ].filter((id): id is string => Boolean(id));

      const uniqueMediaIds = [...new Set(mediaIds)];

      if (uniqueMediaIds.length === 0) {
        setOpenInsuranceModal(false);
        return;
      }

      const mediaResponses = await Promise.all(
        uniqueMediaIds.map((mediaId) => getOneReportMedia(mediaId, userInfo.role.name)),
      );

      const urls = mediaResponses.map((item) => item.url).filter(Boolean);

      if (urls.length === 0) {
        setOpenInsuranceModal(false);
        return;
      }

      setInsuranceImages(urls);
    } catch (error) {
      displayErrorDetails(error);
      setOpenInsuranceModal(false);
    } finally {
      setInsuranceLoading(false);
    }
  };

  const goToDashboard = useCallback(() => roleNavigate('/dashboard'), [roleNavigate]);

  useEffect(() => {
    dispatch(setUploadFileMethod(uploadFile));
  }, [dispatch, uploadFile]);

  useEffect(() => {
    loadImages();
    setAddRequiredField(
      !!(
        thisCase.one_report?.prescriptions?.length &&
        thisCase.type !== CaseType.oral_health_coaching &&
        thisCase.type !== CaseType.care_coordination
      ),
    );
  }, [loadImages, thisCase]);

  const canClientAdminJoin =
    userInfo.role.name === UserRoleName.OrganizationAdmin &&
    userInfo?.organizations?.filter((f) => f.id == thisCase.organization.id).length !== 0;
  useEffect(() => {
    if (
      !thisCase?.id ||
      !(isAssigned || canClientAdminJoin) ||
      ![
        UserRoleName.Provider,
        UserRoleName.CareAdvisor,
        UserRoleName.Collector,
        UserRoleName.OrganizationAdmin,
      ].includes(userInfo.role.name) ||
      ![CaseType.video_call_scheduled, CaseType.oral_health_coaching].includes(thisCase.type)
    ) {
      return;
    }
    void loadRoom();

    pollingRef.current = setInterval(() => {
      void loadRoom();
    }, 30_000);

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [thisCase?.id, thisCase.type, userInfo.role.name, loadRoom, isAssigned]);

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);
    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  useEffect(() => {
    window.addEventListener(VIDEO_PARTICIPANT_PRESENCE_EVENT, onVideoParticipantPresenceEvent);
    return () => window.removeEventListener(VIDEO_PARTICIPANT_PRESENCE_EVENT, onVideoParticipantPresenceEvent);
  }, [onVideoParticipantPresenceEvent]);

  useEffect(() => {
    window.addEventListener('message', handleMessageFromIcore);
    void refreshthisCase(true);

    return () => {
      window.removeEventListener('message', handleMessageFromIcore);
    };
  }, [routeCaseId]);

  useEffect(() => {
    reset(consultationForm);
  }, [consultationForm, reset]);

  useEffect(() => {
    if (thisCase?.medical_history_snapshot && thisCase?.dental_history_snapshot) {
      const medical_history = thisCase.medical_history_snapshot;
      setMedicalHistory(medical_history);
      setMedicalCondition(thisCase.medical_conditions_snapshot);
      setDentalHistory(thisCase.dental_history_snapshot);
      setPharmacyAddress(
        [
          medical_history?.pharmacy_street_address,
          medical_history?.pharmacy_city,
          medical_history?.pharmacy_state,
          medical_history?.pharmacy_zip_code,
        ]
          .filter(Boolean)
          .join(', '),
      );
      setPharmacyPhoneNumber(displayPharmacyPhoneNumber(medical_history?.pharmacy_phone_number || ''));
      return;
    }

    if (thisCase.patient_id) {
      void getFormAnswers(thisCase.patient_id);
    }
  }, [
    getFormAnswers,
    thisCase.id,
    thisCase.medical_history_snapshot,
    thisCase.dental_history_snapshot,
    thisCase.patient_id,
  ]);

  useEffect(() => {
    if (!thisCase?.organization?.id) return;
    const logoPath = isGumCase(thisCase) ? GumLogo : DefaultLogo;
    svgToBase64(logoPath).then((base64Logo) => {
      convertSvgBase64ToPngBase64(base64Logo).then(setPdfLogo);
    });
  }, [thisCase?.organization?.id, thisCase?.client?.code]);

  // Status labels are presentation, not an indication that case data has loaded.
  if (loading || !thisCase?.id || !userInfo) {
    return <Loading fullScreen />;
  }

  const careTeamNode = (
    <>
      {!isMobile && (
        <ConsultationBackButton
          sticky={scroll}
          onClick={() => {
            if (isVisible) {
              goToDashboard();
              return;
            }

            // Opened from a page that set `returnViaHistory`: pop back to its existing history entry rather
            // than pushing a new one, so that page's own Back still leads to where the user came from.
            if ((location.state as { returnViaHistory?: boolean } | null)?.returnViaHistory) {
              roleNavigate(-1);
              return;
            }

            roleNavigate(backPath);
          }}
        />
      )}
      <CareTeamPanel
        thisCase={thisCase}
        userInfo={userInfo}
        redirectToConversationPage={redirectToConversationPage}
        onReassignProvider={handleReassignProvider}
        onReassignCareAdvisor={handleReassignCareAdvisor}
        onReassignCollector={handleReassignCollector}
        setSelectProvidersModal={setSelectProvidersModal}
        onCollectorMessageClick={handleCollectorMessageClick}
      />
    </>
  );

  const patientInfoNode = (
    <PatientInfoPanel
      thisCase={thisCase}
      userInfo={userInfo}
      medicalCondition={medicalCondition}
      medicalHistory={medicalHistory}
      dentalHistory={dentalHistory}
      pharmacyAddress={pharmacyAddress}
      pharmacyPhoneNumber={pharmacyPhoneNumber}
      displayPhoneNumber={displayPhoneNumber}
      secondaryInsurance={secondaryInsurance}
      handleOpenInsuranceCard={handleOpenInsuranceCard}
      redirectToConversationPage={redirectToConversationPage}
      onCollectorMessageClick={handleCollectorMessageClick}
    />
  );

  const caseContentNode = (
    <CaseContentPanel
      thisCase={thisCase}
      userInfo={userInfo}
      timeZone={timeZone}
      shouldHideInCallSection={shouldHideInCallSection}
      showInCallSection={showInCallSection}
      inCallParticipants={inCallParticipants}
      dispatch={dispatch}
      consultationForm={consultationForm}
      setConsultationForm={setConsultationForm}
      allowProviderUpdate={allowProviderUpdate}
      allowAttachmentUpdate={allowAttachmentUpdate}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      onInvalid={onInvalid}
      addPhoto={addPhoto}
      setValue={setValue}
      errors={errors}
      register={register}
      getValues={getValues}
      trigger={trigger}
      control={control}
      addRequiredField={addRequiredField}
      setAddRequiredField={setAddRequiredField}
      changeCaseType={changeCaseType}
      changeCaseStatus={changeCaseStatus}
      setCase={setCase}
      editCase={editCase}
      rescheduleCase={rescheduleCase}
      loading={loading}
      setLoading={setLoading}
      images={images}
      setImages={setImages}
      setEditImageNote={setEditImageNote}
      setRemoveAttachment={setRemoveAttachment}
      setRemoveImage={setRemoveImage}
      updateSelectedImages={updateSelectedImages}
      checkCollapsibleHeaderColor={checkCollapsibleHeaderColor}
      accept={accept}
      onDownloadReport={downloadOHRPdf}
      setEditingFulfillmentApproval={setEditingFulfillmentApproval}
      journeyPaused={journeyPaused}
      journeyAtLimit={journeyAtLimit}
    />
  );

  const containerShellProps = isCollectorCaseView
    ? {
        patientDashboard: true as const,
        grayBackground: true as const,
        // The two-column layout below places its own PhiDisclaimerFooter at
        // the end of the right (case content) column instead — see caseContentNode.
        hidePhiDisclaimerFooter: true as const,
        containerStyle: {
          justifyContent: 'flex-start' as const,
          alignItems: 'stretch' as const,
          overflow: 'hidden' as const,
        },
        childrenStyle: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'stretch',
          paddingTop: '1rem',
          height: 'calc(100vh - 64px)',
          width: '100%',
        },
      }
    : {
        isProvider: true as const,
        grayBackground: true as const,
        childClassName: styles.providerDashboard,
        // The two-column layout below places its own PhiDisclaimerFooter at
        // the end of the right (case content) column instead — see caseContentNode.
        hidePhiDisclaimerFooter: true as const,
        containerStyle: { justifyContent: 'start' as const },
        childrenStyle: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignItems: 'center',
          paddingTop: '2rem',
          height: 'calc(100vh - 64px)',
          width: '100%',
        },
      };

  const pageContent = (
    <>
      <div
        className={`${styles.consultationPageParentDiv} ${
          isCollectorCaseView
            ? mainSidenavCollapsed
              ? styles.consultationPageWithSidenavCollapsed
              : styles.consultationPageWithSidenavExpanded
            : ''
        }`}
      >
        {isMobile ? (
          <ConsultationMobileLayout
            scroll={scroll}
            isVisible={isVisible}
            backPath={backPath}
            goToDashboard={goToDashboard}
            roleNavigate={roleNavigate}
            mobileView={mobileView}
            setMobileView={setMobileView}
            caseContent={caseContentNode}
            patientInfo={patientInfoNode}
            careTeam={careTeamNode}
          />
        ) : (
          <ConsultationDesktopLayout
            leftSide={
              <>
                {careTeamNode}
                {patientInfoNode}
              </>
            }
            rightSide={caseContentNode}
          />
        )}

        <ComplianceChecklistModal
          isOpen={isComplianceOpen}
          onClose={() => setIsComplianceOpen(false)}
          originalCaseType={thisCase.type}
          providerName={thisCase.provider?.full_name || userInfo.full_name}
          onSubmitChecklist={handleComplianceSubmit}
        />

        <OHRReviewDialog
          open={isOHRReviewOpen}
          pdfUrl={generatedPdfUrl || ''}
          onClose={() => setIsOHRReviewOpen(false)}
          onSend={submitToPatient}
        />

        {editImageNote.isOpen ? (
          <ImageNotesModal
            setOpenModal={setEditImageNote}
            thisCase={thisCase}
            setCase={setCase}
            images={images}
            media_id={editImageNote.media_id}
            oneReportId={editImageNote.oneReportId ? editImageNote.oneReportId : ''}
            updateSelectedImages={updateSelectedImages}
            readOnly={!allowAttachmentUpdate || (editImageNote.readOnly as boolean)}
            removeReportImage={(media_id: string, media_src: string) => {
              setRemoveImage({
                isOpen: true,
                media_id,
                media_src,
                oneReportId: editImageNote.oneReportId,
              });
            }}
          />
        ) : null}

        {removeImage.isOpen ? (
          <RemoveOneReportImage
            setOpenModal={setRemoveImage}
            thisCase={thisCase}
            setCase={setCase}
            images={images}
            media_id={removeImage.media_id}
            media_src={removeImage.media_src}
            oneReportId={removeImage.oneReportId ? removeImage.oneReportId : ''}
            updateSelectedImages={updateSelectedImages}
          />
        ) : null}

        {removeAttachment.isOpen ? (
          <RemoveOneReportAttachment
            setOpenModal={setRemoveAttachment}
            thisCase={thisCase}
            setCase={setCase}
            media_id={removeAttachment.media_id}
            media_name={removeAttachment.media_name}
            oneReportId={removeAttachment.oneReportId ? removeAttachment.oneReportId : ''}
          />
        ) : null}

        <InsuranceCardModal
          open={openInsuranceModal}
          onClose={() => {
            setOpenInsuranceModal(false);
            setInsuranceImages([]);
          }}
          images={insuranceImages}
          loading={insuranceLoading}
        />
        {enforceCaAssignmentModal.isOpen && (
          <EnforceAssignCAModal
            setOpenModal={setEnforceCaAssignmentModal}
            caseId={thisCase.id}
            caId={enforceCaAssignmentModal.caId}
            setLoading={setLoading}
            thisCase={thisCase}
            setCase={setCase}
            assignToCareAdvisor={assignToCareAdvisor}
            existCAName={thisCase.care_advisor?.full_name ?? ''}
            editCase={editCase}
            onAssigned={() => refreshthisCase(true)}
          />
        )}
        {selectProvidersModal && (
          <ProviderListTable
            openModal={setSelectProvidersModal}
            thisCase={thisCase}
            setCase={setCase}
            consultationForm={consultationForm}
            setLoading={setLoading}
            assignToProvider={assignToProvider}
          />
        )}

        <Dialog open={collectorConvModal.open} onClose={() => setCollectorConvModal({ open: false, options: [] })}>
          <DialogTitle>Choose a conversation</DialogTitle>
          <DialogContent>
            <List disablePadding>
              {collectorConvModal.options.map((opt) => (
                <ListItemButton
                  key={opt.conversationType}
                  onClick={async () => {
                    setCollectorConvModal({ open: false, options: [] });
                    await joinOrCreateAndOpen(opt);
                  }}
                >
                  <ListItemText
                    primary={opt.label}
                    secondary={opt.sid ? 'Join existing conversation' : 'Start new conversation'}
                  />
                </ListItemButton>
              ))}
            </List>
          </DialogContent>
        </Dialog>
      </div>

      <form
        className={styles.form}
        id="icoreForm"
        target="_blank"
        action={`${process.env.REACT_APP_ICORE_DOMAIN}/api/v1/practice.php`}
        method="POST"
      >
        <input type="text" id="icoreFormData" name="data" readOnly />
        <input type="submit" />
      </form>
    </>
  );

  return (
    <div
      className={styles.scrollableDiv}
      style={isCollectorCaseView ? { width: '100%', maxWidth: '100%' } : undefined}
      onScroll={handleScroll}
    >
      <Container {...containerShellProps}>{pageContent}</Container>
    </div>
  );
};

export default ConsultationPage;

function handleReassignCollector(value: string): Promise<void> {
  throw new Error('Function not implemented.');
}
